import { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import { useDispatch } from 'react-redux'
import { Box, Typography } from '@mui/joy'
import { cleanupRequestStatus } from 'features/billingsSlice'
import routes from 'routes'
import Breadcrumbs from 'components/Breadcrumbs'
import MainLayout from 'components/templates/MainLayout'
import BillingFormSubView from '../common/BillingFormSubView'
import { newBillingObject } from 'utils/config'
import { billingsService } from 'services/billingService'
import { handleErrorMessage } from 'utils/helpers'

const AdminBillingsUserDetails = () => {
  const dispatch = useDispatch()
  // const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const [innerLoading, setInnerLoading] = useState(false)

  useEffect(() => {
    return () => dispatch(cleanupRequestStatus())
  }, [dispatch])

  const handleCreateBilling = (values, { resetForm }) => {
    setInnerLoading(true)
    billingsService
      .adminCreateBilling({ userId: values.user.id, taskIds: values.taskIds })
      .then((res) => {
        console.log(res)
        enqueueSnackbar('Rozliczenie zostało dodane', { variant: 'success' })
        resetForm()
      })
      .catch((err) => {
        console.log(err)
        enqueueSnackbar(handleErrorMessage(err, 'Coś poszło nie tak.'), { variant: 'error' })
      })
      .finally(() => setInnerLoading(false))
  }

  return (
    <MainLayout>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Breadcrumbs items={[{ label: 'Rozliczenia', to: routes.adminBillingsV2 }, { label: 'Nowe rozliczenie' }]} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          Dodaj rozliczenie
        </Typography>
      </Box>

      <BillingFormSubView handleSubmit={handleCreateBilling} initialValues={newBillingObject} loading={innerLoading} />
    </MainLayout>
  )
}

export default AdminBillingsUserDetails
